import { createRoot } from 'react-dom/client';

// third-party
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// only import css
import { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './index.css';

// scroll bar
import 'simplebar-core/dist/simplebar.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

import { persister, store } from 'layout/mantis/store';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container!);




// Extend Quill Font whitelist
const Font = Quill.import("formats/font");
Font.whitelist = [
  "sans", "serif", "monospace", // default
  "amiri", "cairo", "arabic",   // Arabic
  "roboto", "lato", "timesnew", "georgia" // English
];
Quill.register(Font, true);


root.render(
	<ReduxProvider store={store}>
		<PersistGate loading={null} persistor={persister}>
			<App />
		</PersistGate>
	</ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
